var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { HDSButton } from "@here/hds-react-components/Button";
import "./messageBox.scss";
var MessageBox = function (_a) {
    var status = _a.status, primaryMessage = _a.primaryMessage, _b = _a.secondaryMessage1, secondaryMessage1 = _b === void 0 ? null : _b, _c = _a.secondaryMessage2, secondaryMessage2 = _c === void 0 ? null : _c, _d = _a.buttonName, buttonName = _d === void 0 ? null : _d, _e = _a.onClick, onClick = _e === void 0 ? null : _e, _f = _a.statusType, statusType = _f === void 0 ? "" : _f;
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "status ".concat(statusType) }, { children: status })), _jsx("h2", { children: primaryMessage }), secondaryMessage1 && (_jsx("div", __assign({ className: "secondary1" }, { children: secondaryMessage1 }))), secondaryMessage2 && (_jsx("div", __assign({ className: "secondary2" }, { children: secondaryMessage2 }))), buttonName && (_jsx(HDSButton, __assign({ variant: "secondary", className: "messageButton", onClick: function () { return onClick(); } }, { children: buttonName })))] }));
};
export default MessageBox;
